// src/api/services/userApi.js
import { api } from '../configs/axiosConfig';

export const getHomeData = () => api.get('/get-home-data');
export const getSaham = () => api.get('/get-saham');
export const getSahamId = (id) => api.get(`/get-saham/${id}`);
export const getTransaksiId = (id) => api.get(`/get-transaksi/${id}`);
export const postSaham = async(postData) => {
    try {
        const response = await api.post('/post-saham', postData);
        return response.data
    } catch (error) {
        console.error('Error creating post: ', error);
        throw error;
    }
}
export const postTransaksiSaham = async(postData) => {
    try {
        const response = await api.post('/post-transaksi', postData);
        return response.data
    } catch (error) {
        console.error('Error creating post: ', error);
        throw error;
    }
}
export const getSetor = () => api.get('/get-setor');
export const getSahamSetor = (page) => api.get(`/get-saham-setor?page=${page}`);
export const postSetorSaham = async(postData) => {
    try {
        const response = await api.post('/post-setor', postData);
        return response.data
    } catch (error) {
        console.error('Error creating post: ', error);
        throw error;
    }
}
export const getTransaksi = (page) => api.get(`/get-transaksi?page=${page}`);